import { transparentize } from 'polished';
import styled, { css } from 'styled-components';
import { colors } from '@99designs/ui/settings';

export interface StyledLinkProps {
    linkColor: string;
    linkFontFamily: string;
    noUnderline?: boolean;
    size?: string;
}
export function styledLink({
    linkColor,
    linkFontFamily,
    noUnderline,
    size = 'inherit',
}: StyledLinkProps) {
    return css`
        font-size: ${size};
        font-family: ${linkFontFamily};
        text-decoration: none !important;
        color: ${linkColor} !important;
        transition: border-color 0.15s ease-out;
        border-color: ${linkColor !== 'currentColor'
            ? transparentize(0.8, linkColor)
            : transparentize(0.8, colors.puntRoad)};
        border-bottom-width: 2px;
        border-bottom-style: solid;

        ${noUnderline &&
        css`
            border-bottom: none;
        `}

        &:link,
        &:visited {
            border-color: ${linkColor !== 'currentColor'
                ? transparentize(0.8, linkColor)
                : transparentize(0.8, colors.puntRoad)};
        }
        &:hover,
        &:focus {
            border-color: ${linkColor !== 'currentColor'
                ? transparentize(0.6, linkColor)
                : 'currentColor'};
        }
        &:active {
            border-color: transparent;
        }
    `;
}
const StyledLink = styled.a<StyledLinkProps>(styledLink);

export default StyledLink;
